import {Logger} from "./Logger";
import {trackSelfDescribingEvent} from "@snowplow/browser-tracker";

export function SalesForcePersonalizationPlugin(maxChecks) {
    let _logger = Logger(true);
    let _trackerInstance;
    const maxNrChecks = maxChecks || 10;
    const checkTimeout = 500;

    //Check out https://developer.salesforce.com/docs/marketing/personalization/guide/get-started.html
    //In future maybe interact directly with Evergage or SalesforceInteractions objects
    function instrumentPersonalizationExperiments(nrChecks) {
        if (nrChecks >= maxNrChecks) {
            _logger.debug('SalesForcePersonalizationPlugin, stopping after nrChecks', nrChecks);
        } else if (document.querySelectorAll('div[data-evg-campaign-id]').length > 0) { //need more checks here?
            document.querySelectorAll('div[data-evg-campaign-id]').forEach(element => {
                const campaignId = element.dataset.evgCampaignId;
                const experienceId = element.dataset.evgExperienceId;
                const userGroup = element.dataset.evgUserGroup;
                _logger.debug("SF personalization found campaign", campaignId, "experience", experienceId, "user group", userGroup);
                trackSelfDescribingEvent({
                    event: {
                        schema: 'iglu:com.salesforce.personalization/campaign_interaction/jsonschema/1-0-0',
                        data: {
                            campaignId: campaignId,
                            experienceId: experienceId,
                            action: "impression",
                            userGroup: userGroup
                        }
                    }
                });
                element.querySelectorAll('button').forEach(button => {
                    _logger.debug("SF personalization listen to button");
                    button.addEventListener('click', event => {
                        _logger.debug("SF personalization clicked on button of campaign", campaignId, "experience", experienceId, "user group", userGroup, "event target", event.target);
                        trackSelfDescribingEvent({
                            event: {
                                schema: 'iglu:com.salesforce.personalization/campaign_interaction/jsonschema/1-0-0',
                                data: {
                                    campaignId: campaignId,
                                    experienceId: experienceId,
                                    action: "click",
                                    userGroup: userGroup,
                                    buttonText: event.target.innerText
                                }
                            }
                        });
                    });
                });
            });
        } else {
            window.setTimeout(instrumentPersonalizationExperiments, checkTimeout, nrChecks + 1);
        }
    }

    //implementation for methods from Snowplow BrowserPlugin interface
    return {
        activateBrowserPlugin: (tracker) => {
            _trackerInstance = tracker;
            instrumentPersonalizationExperiments(0);
            _logger.debug("Investdata SalesForcePersonalizationPlugin activated on sp instance id and namespace ", tracker.id, tracker.namespace);
        },
        logger: (logger) => _logger = logger
    }
}
